



import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Badge,
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Icon,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Stack,
    Text,
    Tooltip,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import CarouselObjectiveMediaCreative from "components/adspresso/adForms/CarouselObjectiveMediaCreative";
import SingleObjectiveMediaCreative from "components/adspresso/adForms/SingleObjectiveMediaCreative";
import AdPreviewCarousel from "components/adspresso/AdPreviewCarousel";
import CarouselMediaCreative from 'components/adspresso/CarouselMediaCreative';
import CatalogueAdPreview from "components/adspresso/CatalogueAdPreview";
import CatalogueMediaCreative from "components/adspresso/CatalogueMediaCreative";
import CaroAdUpdateForm from "components/adspresso/creativeUpdateForms/CaroAdUpdateForm";
import CarouselMediaUpdateForm from "components/adspresso/creativeUpdateForms/CarouselMediaUpdateForm";
import CatalogueCaroAdUpdateForm from "components/adspresso/creativeUpdateForms/CatalogueCaroAdUpdateForm";
import CatalogueCarouselMediaUpdateForm from "components/adspresso/creativeUpdateForms/CatalogueCarouselMediaUpdateForm";
import CatalogueSingleMediaUpdateForm from "components/adspresso/creativeUpdateForms/CatalogueSingleMediaUpdateForm";
import SingleMediaUpdateForm from "components/adspresso/creativeUpdateForms/SingleMediaUpdateForm";
import SizeMediaUpdateForm from "components/adspresso/creativeUpdateForms/SizeMediaUpdateForm";
import FaceBookPageAdsSelector from "components/adspresso/FaceBookPageAdsSelector";
import InstagramAccountSelector from 'components/adspresso/InstagramAccountSelector';
import SingleMediaCreative from 'components/adspresso/SingleMediaCreative';
import SizeMediaCreative from "components/adspresso/SizeMediaCreative";
import AiImageModal from "components/aiHub/AiImageModal";
import AiVideoModal from "components/aiHub/AiVideoModal";
import DriveModal from "components/drive/DriveModal";
import DeleteConfirmationModal from "components/genericForms/DeleteConfirmationModal";
import { getIn, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { BsStars } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useCreateAdspressoAdHeaderMutation, useGetAdspressoAdDataByCampaignIdQuery, useGetAdspressoCreativeByCampaignIdQuery, useRemoveAdMutation, useRemoveCreativeMutation, useUpdateAdspressoAdCreativeByIdMutation, useUpdateAdspressoAdDataByAdIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetAdspressoAdsetsByCampainIdQuery } from 'store/adspresso/adspressoAdsetapi';
import { formatDateTime, getFileNameWithoutExtension } from "utils/functions";
import { adFormSchema } from '../../utils/schema';

function AdForm({ campaignData, onRefresh, onRefreshComplete }) {

    const toast = useToast();
    const backgroundColor = useColorModeValue('gray.50', 'gray.800');
    const boxBorder = useColorModeValue("gray.200", "purple.800");
    const hoverBoxBorder = useColorModeValue("gray.100", "gray.700");
    const { isOpen: isAiImageModalOpen, onOpen: onAiImageModalOpen, onClose: onAiImageModalClose } = useDisclosure();
    const { isOpen: isAiVideoModalOpen, onOpen: onAiVideoModalOpen, onClose: onAiVideoModalClose } = useDisclosure();
    const [creativesError, setcreativesError] = useState(false);
    const [isDriveOpen, setIsDriveOpen] = useState(false);
    const [mediaType, setMediaType] = useState(null);
    const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
    const [selectedAd, setSelectedAd] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [fileBeingEdited, setFileBeingEdited] = useState(null);
    const { adsAccounts, objective } = campaignData || {};
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const [selectedAdIndex, setSelectedAdIndex] = useState(null);
    const [isAdPreviewModalOpen, setIsAdPreviewModalOpen] = useState(false);
    const hasCatalogId = campaignData?.promoted_object && campaignData?.promoted_object && campaignData?.promoted_object?.some(
        (obj) => !!obj.product_catalog_id
    );

    const [expanded, setExpanded] = useState([0]);

    const { id } = useParams();

    const [createAdspressoAddata, { isLoading: isAddataCreating }] = useCreateAdspressoAdHeaderMutation();

    const { data: adsetsListData, error: adsetsListError, isLoading: isLoadingadsetsList } = useGetAdspressoAdsetsByCampainIdQuery(id, {
        skip: !id,
    });

    const { data: adData, refetch: refetchAdspressoAdData } = useGetAdspressoAdDataByCampaignIdQuery(id, { skip: !id });
    const [updateAdspressoAdDataByAdId, { }] = useUpdateAdspressoAdDataByAdIdMutation({});
    const { data: AdspressoCreatives, refetch: refetchAdspressoCreative } = useGetAdspressoCreativeByCampaignIdQuery(id);
    const [updateAdspressocreativeAds, { isLoading: isAdspressoAdUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
    const [removeCreative] = useRemoveCreativeMutation();
    const [removeAd, removeAdResponse] = useRemoveAdMutation();

    useEffect(() => {
        if (onRefresh) {
            refetchAdspressoCreative();
            refetchAdspressoAdData();
            onRefreshComplete();
        }
    }, [onRefresh]);

    // Formik setup
    const adFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: adData?.name ? adData?.name : '',
            accounts: adData?.adsAccounts || [],
            source: adData?.source || 'MYDRIVE',
            format: AdspressoCreatives?.data[0]?.adType || 'SINGLE',
            useFileName: adData?.name ? false : true,
            enroll_status: 'OPT_OUT',
        },
        validationSchema: adFormSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {

            const filteredAccounts = values.accounts.map(account => {
                // Only include specific fields and remove others, including empty values
                return Object.fromEntries(
                    Object.entries(account)
                        .filter(([key, value]) =>
                            value !== '' && ['adsAccountId', 'instagram_user_id', 'page_id'].includes(key)
                        )
                );
            });

            // If filteredAccounts is empty
            if (filteredAccounts.length === 0) {
                toast({
                    position: "top-right",
                    title: "No pages",
                    description: "Please select pages.",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                setSubmitting(false);
                resetForm();
                return;
            }

            const addataPayload = {
                ...(values.name && { name: values.name }),
                useFileName: values?.name ? values?.useFileName : true,
                campaign: campaignData?._id,
                source: values.source || "MYDRIVE",
                adsAccounts: filteredAccounts,
            };


            if (adData?.name?.length || adData?.useFileName) {

                updateAdspressoAdDataByAdId({ adId: adData?._id, payload: addataPayload }).unwrap()
                    .then(response => {
                        refetchAdspressoAdData();
                        toast({
                            position: "top-right",
                            title: "Ad data saved",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                        //console.log('Ad data created successfully:', response);
                    })
                    .catch(error => {
                        toast({
                            position: "top-right",
                            title: "Error updating ad data",
                            description: error?.data?.message,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                        console.error('Failed to update ad data:', error);
                    })
                    .finally(() => {
                        setSubmitting(false);
                        resetForm();
                    });
            } else {
                createAdspressoAddata(addataPayload).unwrap()
                    .then(response => {
                        refetchAdspressoAdData();
                        toast({
                            position: "top-right",
                            title: "Ad data saved",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                        //console.log('Ad data created successfully:', response);
                    })
                    .catch(error => {
                        toast({
                            position: "top-right",
                            title: "Error creating ad data",
                            description: error?.data?.message,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                        console.error('Failed to create ad data:', error);
                    })
                    .finally(() => {
                        setSubmitting(false);
                        resetForm();
                    });
            }
        },
    });

    // console.log(adFormik.values);

    useEffect(() => {
        if (creativesError) {
            const timer = setTimeout(() => setcreativesError(false), 5000);
            return () => clearTimeout(timer);
        }
    }, [creativesError]);

    useEffect(() => {

        if (adsAccounts && adsetsListData) {

            const hasInitialPageId = adData?.adsAccounts?.some(account => account.page_id && account.page_id.trim() !== '')

            if (!hasInitialPageId) {

                const updatedAccounts = adsAccounts.map(account => {

                    // Check if the account has ANY adset with a destination_type other than "ON_PAGE"
                    const hasOtherDestinationType = adsetsListData?.data?.some(adset =>
                        adset?.destination_type !== "ON_PAGE" &&
                        adset?.promoted_object?.some(obj => obj?.adsAccountId === account?.adsAccountId)
                    );

                    let adset;

                    if (!hasOtherDestinationType) {
                        // Only if there is NO other destination_type, look for ON_PAGE
                        adset = adsetsListData?.data?.find(adset =>
                            adset?.destination_type === "ON_PAGE" &&
                            adset?.promoted_object?.some(obj => obj?.adsAccountId === account?.adsAccountId)
                        );
                    } else {
                        // Otherwise, use your regular logic
                        adset = adsetsListData?.data?.find(adset =>
                            (
                                (adset?.destination_type === "PHONE_CALL") ||
                                adset?.destination_type === "ON_AD" ||
                                objective === "OUTCOME_AWARENESS" || adset?.destination_type === "WHATSAPP"
                            ) &&
                            adset?.promoted_object?.some(obj => obj?.adsAccountId === account?.adsAccountId)
                        );
                    }

                    // If adset is found, get the page_id
                    const selectedPageId = adset?.promoted_object
                        .filter(obj => obj.adsAccountId === account.adsAccountId)
                        .pop()?.page_id;

                    // console.log({ adsetsListData });
                    return {
                        adsAccountId: account?.adsAccountId,
                        page_id: selectedPageId ? selectedPageId : '',
                        instagram_user_id: '',
                    };
                });

                adFormik.setFieldValue('accounts', updatedAccounts);
            }

        }
    }, [adsAccounts, adsetsListData, objective]);


    const handleFacebookPageSelection = (pageId, adsAccountId) => {
        const exists = adFormik.values.accounts.find(a => a.adsAccountId === adsAccountId);
      
        let updatedAccounts;
        if (exists) {
          updatedAccounts = adFormik.values.accounts.map(a =>
            a.adsAccountId === adsAccountId
              ? { ...a, page_id: pageId || '', instagram_user_id: '' }
              : a
          );
        } else {
          // ensure an entry always exists for this adsAccount
          updatedAccounts = [
            ...adFormik.values.accounts,
            { adsAccountId, page_id: pageId || '', instagram_user_id: '' },
          ];
        }
      
        adFormik.setFieldValue('accounts', updatedAccounts);
      
        // mark field as touched so the error shows immediately
        const idx = updatedAccounts.findIndex(a => a.adsAccountId === adsAccountId);
        adFormik.setFieldTouched(`accounts[${idx}].page_id`, true, false);
    };
      

    const handleInstagramPageSelection = (pageId, adsAccountId) => {

        const updatedAccounts = adFormik.values.accounts.map(obj =>
            obj.adsAccountId === adsAccountId ? { ...obj, instagram_user_id: pageId } : obj
        );

        if (!adFormik.values.accounts.find(obj => obj.adsAccountId === adsAccountId)) {
            updatedAccounts.push({ adsAccountId, instagram_user_id: pageId });
        }
        adFormik.setFieldValue('accounts', updatedAccounts);
    };


    const renderCreativeComponent = () => {
        if (objective === 'OUTCOME_APP_PROMOTION' && adFormik.values.format === 'SINGLE' && adsAccounts.length > 0 && adData) {
            return (
                <SizeMediaCreative
                    adData={adData}
                    campaignId={id}
                    adFormik={adFormik}
                    adsAccounts={adsAccounts}
                    objective={objective}
                    adsetsListData={adsetsListData}
                />
            );
        } else if (
            ['OUTCOME_AWARENESS', 'OUTCOME_TRAFFIC', 'OUTCOME_ENGAGEMENT'].includes(objective) &&
            adFormik.values.format === 'SINGLE' &&
            adsAccounts &&
            adData
        ) {
            return (
                <SingleObjectiveMediaCreative
                    adData={adData}
                    campaignId={id}
                    adFormik={adFormik}
                    adsAccounts={adsAccounts}
                    adsetsListData={adsetsListData}
                    objective={objective}
                />
            );
        } else if (
            ['OUTCOME_AWARENESS', 'OUTCOME_TRAFFIC', 'OUTCOME_ENGAGEMENT'].includes(objective) &&
            adFormik.values.format === 'CAROUSEL' &&
            adsAccounts &&
            adData
        ) {
            return (
                <CarouselObjectiveMediaCreative
                    adData={adData}
                    campaignId={id}
                    adFormik={adFormik}
                    adsAccounts={adsAccounts}
                    adsetsListData={adsetsListData}
                    objective={objective}
                />
            );
        } else if (
            adFormik.values.format === 'CAROUSEL' &&
            adsAccounts &&
            adData && !hasCatalogId
        ) {
            return (
                <CarouselMediaCreative
                    adData={adData}
                    campaignId={id}
                    adFormik={adFormik}
                    adsAccounts={adsAccounts}
                    adsetsListData={adsetsListData}
                    objective={objective}
                />
            );
        } else if (
            adFormik.values.format === 'SINGLE' &&
            adsAccounts &&
            adData && !hasCatalogId
        ) {
            return (
                <>
                    <SingleMediaCreative
                        adData={adData}
                        campaignId={id}
                        adFormik={adFormik}
                        adsAccounts={adsAccounts}
                        objective={objective}
                        adsetsListData={adsetsListData}
                    />
                </>
            );
        }

        return null;
    };

    const handleChangeMedia = (file, adAccount) => {

        let mediaType = 'video';

        // Prefer checking ad_formats if available
        if (file?.asset_feed_spec?.ad_formats?.[0] === 'SINGLE_IMAGE') {
            mediaType = 'image';
        } else if (file?.image_hash) {
            mediaType = 'image';
        }

        setMediaType(mediaType);
        setIsDriveOpen(true);
        setFileBeingEdited(file);
        setSelectedAdAccounts([adAccount]);
    };

    const handleChangeAiMedia = (file, adAccount) => {
        setFileBeingEdited(file);
        setSelectedAdAccounts([adAccount]);
        if (file?.video_id) {
            onAiVideoModalOpen();
        } else {
            onAiImageModalOpen();
        }
    };

    const handleAiUploadedMedia = (data) => {
        const mappedMediaFiles = data.map(item => {
            const dynamicKeyData = item[item?.name] || {};

            return {
                creativeType: item?.creativeType,
                creativeId: item?.creativeId,
                source: item?.source,
                url: dynamicKeyData?.url || "",
                picture: dynamicKeyData?.url || "",
                hash: item?.hash,
                name: item?.name,
                adsAccount: {
                    adsAccountId: item?.adsAccount?.adsAccountId
                }
            };
        });

        if (mappedMediaFiles.length > 0) {
            handleFileSelect(mappedMediaFiles)
        }
    };

    const handleFileSelect = (files) => {
        if (files.length > 0) {
            // Handle update scenario
            const selectedFile = files[0];

            const strippedName = getFileNameWithoutExtension(selectedFile?.name)?.trim();
            const fileName = strippedName ? strippedName : `Ad_${formatDateTime()}`;

            const payload = {
                [selectedFile?.creativeType === 'video' ? 'video_id' : 'image_hash']: selectedFile?.creativeId,
                ...(selectedFile?.creativeType === 'image' ? { url: selectedFile?.url } : { thumbnail: selectedFile?.picture, url: selectedFile?.source }),
                hash: selectedFile?.hash,
                fileName: fileName,
                // degrees_of_freedom_spec : {
                //     creative_features_spec: {
                //         standard_enhancements: {
                //             enroll_status: "OPT_OUT"
                //         }
                //     }
                // }
            };

            updateAdspressocreativeAds({ adcreativeId: fileBeingEdited?._id, payload }).unwrap()
                .then(response => {
                    //console.log('Ad creative updated successfully:', response);
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating image",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                });
        }
        setFileBeingEdited(null);
    };


    const handleDeleteCreative = (creativeId) => {

        removeCreative(creativeId)
            .unwrap()
            .then(response => {
                toast({
                    position: "top-right",
                    title: "Ad creative deleted",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch(error => {
                toast({
                    position: "top-right",
                    title: "Error deleting Ad creative",
                    status: "error",
                    description: error?.data?.message,
                    duration: 4000,
                    isClosable: true,
                });
                //console.error('Failed to delete Ad creative:', error);
            });
    };

    const handleDeleteAd = (adId) => {
        removeAd(adId)
            .unwrap()
            .then(response => {
                toast({
                    position: "top-right",
                    title: "Ad deleted",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch(error => {
                toast({
                    position: "top-right",
                    title: "Error deleting Ad",
                    status: "error",
                    description: error?.data?.message,
                    duration: 4000,
                    isClosable: true,
                });
            });
    };

    const openPreviewModal = (index) => {
        setSelectedAdIndex(index);
        setIsAdPreviewModalOpen(true);
    };

    const uploadedCreativesList = AdspressoCreatives?.data
        ?.filter(creative => creative?.adcreatives?.length > 0)
        ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
        ?.map((creative, index) => {
            if (adFormik?.values?.format === creative?.adType) {

                return (
                    <Box key={creative?._id + index} p={'10px'} borderWidth={1} borderRadius="md" borderColor={boxBorder}>
                        <Flex justifyContent={'space-between'}>
                            <Text fontSize={'14px'} fontWeight={'bold'}>Ad Account: {creative?.adsAccount?.adsAccountName}</Text>
                            <Tooltip label="Delete" fontSize="xs">
                                <Box>
                                    <Icon
                                        color={userInfo?.role !== 'client' ? 'gray.300' : 'red.500'}
                                        _hover={{ color: 'gray.400' }}
                                        as={MdDelete}
                                        cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                        boxSize={5}
                                        onClick={() => {
                                            if (userInfo?.role === 'client') {
                                                setSelectedAd(creative?._id);
                                                setModalOpen(true);
                                            }
                                        }}
                                        pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                    />
                                </Box>
                            </Tooltip>
                        </Flex>
                        <Flex align="flex-start" alignItems={'center'} fontSize="14px" fontWeight={'bold'} mb={2}>
                            <Text mr={1}>Ad Set:</Text>
                            <Text>
                                {creative?.adsets?.map(adset => adset.name).join(', ')}
                            </Text>
                        </Flex>

                        {/* Small Image Preview */}
                        <Flex wrap="wrap" gap={2} direction="column">
                            {creative?.adType === 'CAROUSEL' && (
                                <Flex>
                                    <Button
                                        onClick={() => openPreviewModal(creative?.adType)}
                                        bg={'gray.50'}
                                        borderWidth={1}
                                        size="xs"
                                        fontSize={'12px'}
                                        gap={2}
                                    >
                                        <FaEye />
                                        Ad preview
                                    </Button>
                                </Flex>
                            )}

                            {(selectedAdIndex === creative?.adType) && (
                                <Modal
                                    isOpen={isAdPreviewModalOpen}
                                    onClose={() => setIsAdPreviewModalOpen(false)}
                                    size="3xl"
                                    scrollBehavior={"inside"}
                                >
                                    <ModalOverlay />
                                    <ModalContent minH={'60vh'}>
                                        <ModalHeader>Ad preview</ModalHeader>
                                        <ModalCloseButton />
                                        <ModalBody>
                                            {creative && adData ? (() => {
                                                const isCarousel = creative?.adType === 'CAROUSEL';
                                                const isCatalogue = isCarousel && creative?.force_single_link === 'false';
                                                const isStandardCarousel = isCarousel && creative?.force_single_link !== 'false';

                                                if (isCatalogue) {
                                                return (
                                                    <CatalogueAdPreview
                                                    file={creative}
                                                    adData={adData}
                                                    creatives={creative}
                                                    />
                                                );
                                                }

                                                if (isStandardCarousel) {
                                                return (
                                                    <AdPreviewCarousel
                                                    file={creative}
                                                    adData={adData}
                                                    creatives={creative}
                                                    />
                                                );
                                                }

                                                return <Text>No preview available</Text>;
                                            })() : null}
                                        </ModalBody>
                                        <ModalFooter justifyContent={'flex-start'} css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }} py={2}>
                                            <Text fontSize={'14px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                            Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                                            </Tooltip>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>
                            )}


                            {creative?.adcreatives?.map((file, fileIndex) => {
        
                                return (
                                    <Box key={file?._id}>

                                        {/* Based on adType */}
                                        {(() => {
                                                if (creative.adType === 'SINGLE' && file?.asset_feed_spec?.ad_formats && file) {
                                                return (
                                                    <SizeMediaUpdateForm
                                                        adData={adData}
                                                        adAccount={creative?.adsAccount}
                                                        creative={file}
                                                        creatives={creative}
                                                        objective={objective}
                                                        destinationType={creative?.adsets[0]?.destination_type}
                                                        onDelete={handleDeleteCreative}
                                                        onChangeImage={handleChangeMedia}
                                                    />
                                                );
                                                }

                                                if (creative.adType === 'SINGLE' && !file?.asset_feed_spec?.ad_formats && !file?.product_set_id) {
                                                return (
                                                    <SingleMediaUpdateForm
                                                        adData={adData}
                                                        adAccount={creative?.adsAccount}
                                                        creative={file}
                                                        creatives={creative}
                                                        objective={objective}
                                                        destinationType={creative?.adsets[0]?.destination_type}
                                                        onDelete={handleDeleteCreative}
                                                        onChangeImage={handleChangeMedia}
                                                        onAiModalOpen={handleChangeAiMedia}
                                                    />
                                                );
                                                }

                                                if (creative.adType === 'SINGLE' && !file?.asset_feed_spec?.ad_formats && file?.product_set_id) {
                                                return (
                                                    <CatalogueSingleMediaUpdateForm
                                                        adData={adData}
                                                        adAccount={creative?.adsAccount}
                                                        creative={file}
                                                        creatives={creative}
                                                        applinkTreatment={creative?.applink_treatment}
                                                        objective={objective}
                                                        destinationType={creative?.adsets[0]?.destination_type}
                                                        onDelete={handleDeleteCreative}
                                                        onChangeImage={handleChangeMedia}
                                                        onAiModalOpen={handleChangeAiMedia}
                                                    />
                                                );
                                                }

                                                if (creative.adType === 'CAROUSEL' && !file?.asset_feed_spec?.ad_formats && file?.product_set_id) {
                                                    return (
                                                        <CatalogueCarouselMediaUpdateForm
                                                            creative={file}
                                                            onDelete={handleDeleteCreative}
                                                        />
                                                    );
                                                }

                                                if (creative.adType === 'CAROUSEL' && !file?.asset_feed_spec?.ad_formats && !file?.product_set_id) {
                                                return (
                                                    <CarouselMediaUpdateForm
                                                        adData={adData}
                                                        adAccount={creative?.adsAccount}
                                                        creative={file}
                                                        objective={objective}
                                                        destinationType={creative?.adsets[0]?.destination_type}
                                                        onDelete={handleDeleteCreative}
                                                        onChangeImage={handleChangeMedia}
                                                    />
                                                );
                                                }

                                                return null;
                                            })()
                                            }

                                    </Box>
                                );
                            })}

                            {creative?.adType === 'CAROUSEL' ? (
                                creative?.force_single_link === "false" ? (
                                    <CatalogueCaroAdUpdateForm adData={adData} adAccount={creative?.adsAccount} creative={creative} objective={objective} />
                                ) : (
                                    <CaroAdUpdateForm adData={adData} adAccount={creative?.adsAccount} creative={creative} objective={objective} />
                                )
                            ) : null}
                        </Flex>
                    </Box>
                );
            }
            return null;
        });

    const confirmDelete = () => {
        if (selectedAd) {
            handleDeleteAd(selectedAd);
            setModalOpen(false);
            setSelectedAd(null);
        }
    };

    const creativesList = uploadedCreativesList?.filter(item => item !== null) || [];

    return (

        <>

            {/* Modal for Image/Video */}
            {/* <Modal isOpen={issetModalOpen} onClose={closeModal} size="sm">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader />
                    <ModalCloseButton />
                    <ModalBody>
                        {selectedMedia ? (
                            selectedMedia?.video_id ? (
                                <video
                                    src={selectedMedia?.url}
                                    controls
                                    style={{ width: '100%' }}
                                />
                            ) : (
                                <Image
                                    src={selectedMedia?.url}
                                    alt="image"
                                    mx={'auto'} maxW={'100%'} maxH={'50vh'} borderRadius={2}
                                />
                            )
                        ) : (
                            <Box>No media selected</Box>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal> */}


            <Modal
                isOpen={isAiImageModalOpen}
                onClose={onAiImageModalClose} scrollBehavior={"inside"}
                size={"5xl"}
                isCentered={true}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Image Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                            <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AiImageModal
                            selectedAdAccounts={selectedAdAccounts}
                            onClose={onAiImageModalClose}
                            onUploadComplete={handleAiUploadedMedia}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Upload Video Modal */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isAiVideoModalOpen}
                scrollBehavior={"inside"}
                onClose={onAiVideoModalClose}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Video Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                                            <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                                                <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalBody>
                        <AiVideoModal
                            isOpen={isAiVideoModalOpen}
                            selectedAdAccounts={selectedAdAccounts}
                            onClose={() => {
                                onAiVideoModalClose();
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <DriveModal
                isDriveModalOpen={isDriveOpen}
                mediaType={mediaType}
                onClose={() => {
                    setIsDriveOpen(false);
                    setMediaType(null);
                }}
                mediaFormat={adFormik?.values?.format}
                onSubmit={handleFileSelect}
                selectedAdAccounts={selectedAdAccounts}
                uploadPurpose={'update'}
            />

            <DeleteConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
                message="Do you wish to proceed with deleting this Ad?"
            />

            <Flex 
                p={{ base: 3, sm: 4, md: 6 }}
                gap={{ base: 3, md: 4 }}
                height="100%"
                overflowX={{ base: "auto", lg: "visible" }} 
                overflowY="hidden"
            >
                {/* LEFT: form column */}
                <Box
                    flexShrink={0}
                    w={{ base: "100%", sm: "80%", lg: "60%" }}
                    maxH={"100vh"}
                    overflowY={"auto"}
                    display="flex"
                    flexDirection="column"
                >
                    <form onSubmit={adFormik.handleSubmit}>
                    {/* Ad Name Section */}
                    <Flex
                        direction="column"
                        mb={{ base: 3, md: 4 }}
                        bg={backgroundColor}
                        p={{ base: 3, md: 4 }}
                        borderRadius="md"
                        gap={{ base: 3, md: 4 }}
                    >
                        <Flex direction="column" gap={2}>
                        <Flex align="center" gap={1}>
                            <Text fontWeight="bold">Ad name</Text>
                            <Text as="span" fontSize="18px" color="red.400" mr={2}>
                            *
                            </Text>
                        </Flex>

                        <Input
                            placeholder="Enter your ad name here..."
                            name="name"
                            value={adFormik.values.name}
                            onChange={(e) => {
                            adFormik.handleChange(e);
                            adFormik.setFieldValue("useFileName", !e.target.value);
                            }}
                            onBlur={adFormik.handleBlur}
                            size="sm"
                            borderRadius="md"
                            isDisabled={
                            userInfo?.role !== "client" || adFormik.values.useFileName
                            }
                            // ensure comfortable tap targets on mobile
                            h={{ base: 10, md: 8 }}
                        />

                        <Flex direction="column" gap={2}>
                            <Checkbox
                            name="useFileName"
                            isChecked={adFormik.values.useFileName}
                            onChange={() =>
                                adFormik.setFieldValue(
                                "useFileName",
                                !adFormik.values.useFileName
                                )
                            }
                            isDisabled={Boolean(adFormik.values.name)}
                            size="sm"
                            colorScheme="brand"
                            pl={1}
                            >
                            Using file name as Ad name
                            </Checkbox>
                        </Flex>
                        </Flex>

                        {/* Identity Section */}
                        <Flex direction="column" gap={2}>
                        <Text fontWeight="bold">Identity</Text>

                        <Accordion
                            allowMultiple
                            index={expanded}
                            onChange={(val) => {
                                const arr = Array.isArray(val) ? val : [val];
                                setExpanded(arr);
                            }}
                            >
                            {adsAccounts?.map((account, i) => {
                                // ---- Your destination-type logic  ----
                                const hasOtherDestinationType = adsetsListData?.data?.some(
                                (adset) =>
                                    adset?.destination_type !== "ON_PAGE" &&
                                    adset?.promoted_object?.some(
                                    (obj) => obj?.adsAccountId === account?.adsAccountId
                                    )
                                );

                                let adset;
                                if (!hasOtherDestinationType) {
                                adset = adsetsListData?.data?.find(
                                    (adset) =>
                                    adset?.destination_type === "ON_PAGE" &&
                                    adset?.promoted_object?.some(
                                        (obj) => obj?.adsAccountId === account?.adsAccountId
                                    )
                                );
                                } else {
                                adset = adsetsListData?.data?.find(
                                    (adset) =>
                                    ((adset?.destination_type === "PHONE_CALL" &&
                                        objective !== "OUTCOME_ENGAGEMENT") ||
                                        adset?.destination_type === "ON_AD" ||
                                        objective === "OUTCOME_AWARENESS" ||
                                        adset?.destination_type === "WHATSAPP") &&
                                    adset?.promoted_object?.some(
                                        (obj) => obj?.adsAccountId === account?.adsAccountId
                                    )
                                );
                                }

                                const selectedPageId = adset?.promoted_object
                                    ?.filter((obj) => obj.adsAccountId === account.adsAccountId)
                                    ?.pop()?.page_id;

                                // Per-item error state
                                const idx = adFormik.values.accounts.findIndex(
                                    (a) => a.adsAccountId === account.adsAccountId
                                    );

                                const isTouched = idx > -1 && getIn(adFormik.touched, `accounts[${idx}].page_id`);
                                const errorMsg = idx > -1 && getIn(adFormik.errors, `accounts[${idx}].page_id`);
                                const showError = isTouched && errorMsg;

                                return (
                                <AccordionItem
                                    key={account.adsAccountId}
                                    border="1px solid"
                                    borderColor={boxBorder}
                                    borderRadius="md"
                                    mb={2}
                                    overflow="hidden"
                                >
                                    <h2>
                                    <AccordionButton 
                                        px={3} 
                                        py={2} 
                                        justifyContent="space-between"
                                        _hover={{bg: hoverBoxBorder}}
                                        >
                                        <Flex gap={1} flex="80%" direction="column">
                                            <Flex>
                                                <Text fontWeight="bold" fontSize="14px">
                                                    {account?.adsAccountName}
                                                </Text>
                                            </Flex>
                                            <Flex>
                                                <Text fontSize="12px">
                                                    {account?.adsAccountId}
                                                </Text>
                                            </Flex>
                                        </Flex>

                                        <Flex gap={2} align="flex-end" justifyContent="flex-end" flex="20%">
                                            {showError && (
                                            <Badge colorScheme="red" variant="subtle">
                                                required
                                            </Badge>
                                            )}
                                            <AccordionIcon />
                                        </Flex>
                                    </AccordionButton>
                                    </h2>

                                    <AccordionPanel p={3}>
                                    <Box>
                                        <Box>
                                            <Flex align="center" gap={1} wrap="wrap" mb={2}>
                                                <Text fontWeight="bold">Facebook pages</Text>
                                                <Text as="span" fontSize="18px" color="red.400" mr={2}>
                                                    *
                                                </Text>
                                                <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="sm" p="5px">
                                                    <Text>
                                                        Your Facebook Pages or Instagram accounts represents your
                                                        business in ads.
                                                    </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                                >
                                                <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <FaceBookPageAdsSelector
                                                pageIdToSend={selectedPageId || ""}
                                                adsAccount={account}
                                                objective={objective}
                                                destinationType={
                                                    adsetsListData?.data?.some(
                                                    (a) => a?.destination_type === "WEBSITE_AND_LEAD_FORM"
                                                    )
                                                    ? "WEBSITE_AND_LEAD_FORM"
                                                    : undefined
                                                }
                                                selectedPageId={
                                                    selectedPageId ||
                                                    adData?.adsAccounts?.find(
                                                    (a) => a?.adsAccountId === account?.adsAccountId
                                                    )?.page_id
                                                }
                                                onSelectedPage={(page) =>
                                                    handleFacebookPageSelection(page, account.adsAccountId)
                                                }
                                                key={`fb_pages_${account?.adsAccountId}`}
                                            />

                                            {showError && (
                                            <Text color="red.500" fontSize="12px" mt={1}>
                                                {errorMsg}
                                            </Text>
                                            )}
                                        </Box>
                                       
                                        {/* Instagram Selector If No ON_PAGE */}
                                        {!adsetsListData?.data?.some(
                                        (adset) => adset?.destination_type === "ON_PAGE"
                                        ) && (
                                        <Box mt={4}>
                                             <Text fontWeight="bold" mb={2}>Instagram accounts</Text>
                                            <InstagramAccountSelector
                                                adsAccount={account}
                                                selectedInstPageId={
                                                    adData?.adsAccounts?.filter(
                                                    (account_) =>
                                                        account_?.adsAccountId === account?.adsAccountId
                                                    )?.[0]?.instagram_user_id
                                                }
                                                onSelectedPage={(page) =>
                                                    handleInstagramPageSelection(page, account.adsAccountId)
                                                }
                                                pageID={
                                                    adFormik.values?.accounts?.find(
                                                    (acc) => acc.adsAccountId === account.adsAccountId
                                                    )?.page_id ||
                                                    adData?.adsAccounts?.filter(
                                                    (account_) =>
                                                        account_?.adsAccountId === account?.adsAccountId
                                                    )?.[0]?.page_id
                                                }
                                                key={`insta_accounts_${account?.adsAccountId}_${i}`}
                                                isNewAdCreating={true}
                                            />
                                        </Box>
                                        )}
                                    </Box>
                                    </AccordionPanel>
                                </AccordionItem>
                                );
                            })}
                        </Accordion>
                      
                        </Flex>

                        <Flex justify="flex-start">
                        <Button
                            colorScheme="brand"
                            isLoading={adFormik.isSubmitting}
                            type="submit"
                            size="sm"
                            isDisabled={userInfo?.role !== "client"}
                        >
                            Save
                        </Button>
                        </Flex>
                    </Flex>

                    {/* Ad Setup Section */}
                    <Flex
                        direction="column"
                        mb={{ base: 3, md: 4 }}
                        bg={backgroundColor}
                        p={{ base: 3, md: 4 }}
                        borderRadius="md"
                        gap={{ base: 2, md: 3 }}
                    >
                        {/* Creative Source Section */}
                        <Flex direction="column" gap={2}>
                        <Flex align="center" wrap="wrap">
                            <Text fontWeight="bold">Creative source&nbsp;</Text>
                            <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="sm" p="5px">
                                <Text>
                                    Choose how you'd like to provide the media for your ad.
                                </Text>
                                </Box>
                            }
                            fontSize="md"
                            >
                            <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                        </Flex>

                        {/* Format Section */}
                        <Flex direction="column" gap={2}>
                        <Flex align="center" wrap="wrap">
                            <Text fontWeight="bold">Format&nbsp;</Text>
                            <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="sm" p="5px">
                                <Text>Choose how you'd like to structure your ad.</Text>
                                </Box>
                            }
                            fontSize="md"
                            >
                            <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>

                        <RadioGroup
                            onChange={(value) => {
                            adFormik.setFieldValue("format", value);
                            adFormik.setFieldValue("mediaOption", "");
                            }}
                            value={adFormik.values.format}
                        >
                            <Stack spacing={4} direction="column">
                            <Flex direction="column">
                                <Flex align="center">
                                <Radio colorScheme="brand" value="SINGLE" />
                                <Text fontWeight="bold" ml={2}>
                                    Single image or video
                                </Text>
                                </Flex>
                                <Text fontSize="sm" ml={6}>
                                One image or video, or a slideshow with multiple images
                                </Text>
                            </Flex>

                            <Flex direction="column">
                                <Flex align="center">
                                <Radio colorScheme="brand" value="CAROUSEL" />
                                <Text fontWeight="bold" ml={2}>
                                    Carousel
                                </Text>
                                </Flex>
                                <Text fontSize="sm" ml={6}>
                                Two or more scrollable images or videos
                                </Text>
                            </Flex>
                            </Stack>
                        </RadioGroup>
                        </Flex>

                        <Divider my={2} />

                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" gap={2}>
                        <Checkbox
                            onChange={(e) => {
                            adFormik.setFieldValue(
                                "enroll_status",
                                e.target.checked ? "OPT_IN" : "OPT_OUT"
                            );
                            }}
                            colorScheme="brand"
                            isChecked={adFormik.values.enroll_status === "OPT_IN"}
                        >
                            <Flex align="center" wrap="wrap">
                            <Text fontWeight="bold">Multi-advertiser ads&nbsp;</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                <Box fontSize="sm" p="5px">
                                    <Text>
                                    Your ads can appear alongside other ads in the same ad
                                    unit to help people discover products and services
                                    from businesses that are personalized to them. Your ad
                                    creative may be resized or cropped to fit the ad unit.
                                    </Text>
                                </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                            </Flex>
                        </Checkbox>
                        </Flex>
                    </Flex>

                    {!(['SINGLE', 'CAROUSEL'].includes(adFormik.values.format) && ["OUTCOME_SALES"].includes(objective) && hasCatalogId) ? (
                        <Flex
                            direction="column"
                            mb={{ base: 3, md: 4 }}
                            bg={backgroundColor}
                            p={{ base: 3, md: 4 }}
                            borderRadius="md"
                            gap={{ base: 2, md: 3 }}
                        >
                            {/* Ad creative Section */}
                            <Flex direction="column">
                                <Box mb="10px">
                                    <Flex align="center" wrap="wrap">
                                    <Text fontWeight="bold">Ad creative&nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>
                                            Add a variety of creative elements and group the ones
                                            that can be shown together. We'll combine the right
                                            elements to show each person the version of your ad
                                            that they're most likely to engage with.
                                            </Text>
                                        </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                            </Flex>
                        </Box>

                            {/* Media selection */}
                            <Flex direction="column" gap={2}>
                                <Flex
                                    align="center"
                                    justify="space-between"
                                    gap={{ base: 2, sm: 0 }}
                                >
                                    <Flex align="center" gap={1}>
                                    <Text fontWeight="bold">Media</Text>
                                    <Text as="span" fontSize="18px" color="red.400">
                                        *
                                    </Text>
                                    </Flex>
                                </Flex>

                                <Box>{renderCreativeComponent()}</Box>
                            </Flex>
                            </Flex>
                        </Flex>
                    ) :
                        <CatalogueMediaCreative
                            adData={adData}
                            campaignId={id}
                            adFormik={adFormik}
                            adsAccounts={adsAccounts}
                            objective={objective}
                            adsetsListData={adsetsListData}
                        />
                    }
                    </form>
                </Box>

                {/* RIGHT: preview/list column */}
                <Box
                    flexShrink={0}
                    w={{ base: "90%", sm: "80%", lg: "40%" }} 
                    bg={creativesList?.length > 0 ? backgroundColor : undefined}
                    borderRadius="md"
                    p={{ base: creativesList?.length > 0 ? 3 : 0, md: 4 }}
                    maxH={"100vh"}
                    overflowY={"auto"}
                >
                    {creativesList?.length > 0 ? (
                        <Flex direction="column" gap={{ base: 2, md: 3 }}>
                            {creativesList}
                        </Flex>
                    ) : null}
                </Box>
            </Flex>
        </>
    );
}

export default AdForm;

